import { Injectable, EventEmitter } from '@angular/core';
import { BreadCrumb } from '../../model/common/bread-crumb';
/**
 * Breadcrumb service to keep track of the users recently viewed pages.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class BreadCrumbBuilderService {
  breadCrumbChangedEvent: EventEmitter<any>;
  breadCrumbSelectedEvent: EventEmitter<any>;
  breadCrumbs: any[];

  /**
   *
   */
  constructor() {
    this.breadCrumbs = [];
    this.breadCrumbChangedEvent = new EventEmitter<any>();
    this.breadCrumbSelectedEvent = new EventEmitter<any>();
  }

  /**
   * Adds a breadcrumb to the list.  This is normally called by a containers ngOnInit method.
   * When the breadcrumb is added a breadcrumbchangedevent is fired.
   *
   * Note: We ignore breadcrumbs if they have the same label as an already existing entry.  We may need to update that
   * entry instead?
   *
   * @param data BreadCrumb object to add to the list.
   */
  addBreadCrumb(data: BreadCrumb) {
    if (this.breadCrumbs.some((element) => element.label === data.label)) {
      return;
    }

    if (data.sendSelectEvent === true) {
      data.command = this.sendEvent.bind(this);
    }
    this.breadCrumbs = [...this.breadCrumbs, data];
    this.breadCrumbChangedEvent.emit(this.breadCrumbs);
  }

  resetAndAddBreadCrumb(data: BreadCrumb) {
    this.clearBreadCrumbs();
    this.addBreadCrumb(data);
  }

  removeBreadCrumb(data: BreadCrumb | null | undefined) {
    if (!data) {
      return;
    }

    this.breadCrumbs.forEach((b, i, arr) => {
      if (b.label === data.label) {
        arr.splice(i, 1);
      }
    });
    this.breadCrumbs = [...this.breadCrumbs.slice()];
  }

  /**
   * Clears the breadcrumb list and fires a breadcrumbchanged event.
   */
  clearBreadCrumbs() {
    this.breadCrumbs = [];
    this.breadCrumbChangedEvent.emit(this.breadCrumbs);
  }

  sendEvent($event: any) {
    this.breadCrumbSelectedEvent.emit($event);
  }

  removeLaterCrumbs(breadCrumb: BreadCrumb) {
    const idx = this.breadCrumbs.findIndex(
      (bc: BreadCrumb) => bc.label === breadCrumb.label
    );
    this.breadCrumbs = [...this.breadCrumbs.slice(0, idx + 1)];
    this.breadCrumbChangedEvent.emit(this.breadCrumbs);
  }
}
